import { ReactComponent as IconA } from "./icon-a.svg";
import { ReactComponent as IconB } from "./icon-b.svg";
import { ReactComponent as IconEmptyData } from "./icon-empty-data.svg";
import { ReactComponent as IconUploadImage } from "./icon-upload-image.svg";
import { ReactComponent as Logo } from "./logo.svg";
import { ReactComponent as IconBoat } from "./icon-boat.svg";
import { ReactComponent as EmptyImage } from "./empty-image.svg";
import { ReactComponent as IconBack } from "./icon-back.svg";

const svgs = {
  IconA,
  IconB,
  IconEmptyData,
  IconUploadImage,
  Logo,
  IconBoat,
  EmptyImage,
  IconBack,
};

export default function Svg({ iconName, className = "", style }) {
  const IconComponent = svgs[iconName]; // เลือก component ตามชื่อ iconName ที่ส่งมา
  return IconComponent ? (
    <>
      <IconComponent className={className} style={style} />
    </>
  ) : null; // แสดง SVG Component
}
